module.exports = __webpack_public_path__ + "static/BelleDoor-93c2513754f85d4a4a1e4c564245537c.png";